import * as React from "react";
import {FormattedMessage} from "react-intl";
import translations from "./translations";

export class Footer extends React.Component {
  public backToTop = () => {
    window.scrollTo(0, 0);
  };

  public render() {
    return (
      <React.Fragment>
        <div className="hero-foot">
          <div className="columns" style={{textAlign: "center"}}>
            <div className="column">
              <a onClick={this.backToTop}>
                {/*tslint:disable-line*/}
                <span className="icon">
                  <i className="fa fa-arrow-up" />
                </span>
                <FormattedMessage {...translations.backtoptop} />
              </a>
            </div>
            <div className="column">
              <a href="https://campaign-logger.com/#/privacy" target="newwindow">
                <FormattedMessage {...translations.cookies} />
              </a>
            </div>
            <div className="column">
              <a href="https://campaign-logger.com/#/disclaimer" target="newwindow">
                <FormattedMessage {...translations.disclaimer} />
              </a>
            </div>
            <div className="column">
              <a href="https://campaign-logger.com/#/lnotice" target="newwindow">
                <FormattedMessage {...translations.legalnotice} />
              </a>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/Footer.tsx